<template>
  <fa-icon icon="exclamation-circle" class="has-text-danger" />
</template>
